export const flexCenter = () => {
  return `
    display: flex;
    align-items: center;
    justify-content: center;
    `;
};
